export enum ErrorCode {
  GENERAL_ERROR = 'GENERAL_ERROR',
  BLOCKING_PAYMENTS = 'BLOCKING_PAYMENTS',
  LIABILITY_STATUS_TRANSITION_NOT_ALLOWED = 'LIABILITY_STATUS_TRANSITION_NOT_ALLOWED',
  LIABILITY_NOTIFICATION_STATUS_TRANSITION_NOT_ALLOWED = 'LIABILITY_NOTIFICATION_STATUS_TRANSITION_NOT_ALLOWED',
  PAYMENT_STATUS_TRANSITION_NOT_ALLOWED = 'PAYMENT_STATUS_TRANSITION_NOT_ALLOWED',
  MESSAGE_STATUS_TRANSITION_NOT_ALLOWED = 'MESSAGE_STATUS_TRANSITION_NOT_ALLOWED',
  LIABILITY_VISIBILITY_CANNOT_BE_CHANGED = 'LIABILITY_VISIBILITY_CANNOT_BE_CHANGED',
  UNKNOWN_LIABILITY_SOURCE = 'UNKNOWN_LIABILITY_SOURCE',
  INVALID_RECURRING_LIABILITY_FIRST_PAYMENT_DATE = 'INVALID_RECURRING_LIABILITY_FIRST_PAYMENT_DATE',
  LIABILITY_AMOUNT_CANNOT_BE_CHANGED = 'LIABILITY_AMOUNT_CANNOT_BE_CHANGED',
  USERPANEL_SCRAPER_EXCEPTION = 'USERPANEL_SCRAPER_EXCEPTION',
  PAYMENT_METHOD_DETAILS_EXCEPTION = 'PAYMENT_METHOD_DETAILS_EXCEPTION',
  PAYMENT_EXCEPTION = 'PAYMENT_EXCEPTION',
  REFUND_EXCEPTION = 'REFUND_EXCEPTION',
  CUSTOMER_BILLER_HAS_LIABILITIES_WITH_PENDING_PAYMENT = 'CUSTOMER_BILLER_HAS_LIABILITIES_WITH_PENDING_PAYMENT',
  LIABILITIES_WITH_UNKNOWN_STATUS = 'LIABILITIES_WITH_UNKNOWN_STATUS',
  CUSTOMER_CART_LIMIT_REACHED = 'CUSTOMER_CART_LIMIT_REACHED',
  LIABILITY_ALREADY_PAID = 'LIABILITY_ALREADY_PAID',
  INVALID_PBL_TOKEN = 'INVALID_PBL_TOKEN',
  NO_SUGGESTED_LIABILITY_TO_PAY = 'NO_SUGGESTED_LIABILITY_TO_PAY',
  DELEGATED_AUTOMATIC_PAYMENT_ENABLED = 'DELEGATED_AUTOMATIC_PAYMENT_ENABLED',
  PAYMENT_ALREADY_STARTED = 'PAYMENT_ALREADY_STARTED',
  TOP_UP_CANNOT_BE_EXECUTED = 'TOP_UP_CANNOT_BE_EXECUTED',
  TOP_UP_CLIENT_ERROR = 'TOP_UP_CLIENT_ERROR',
  INVALID_LIABILITIES_PAYMENT_TYPE = 'INVALID_LIABILITIES_PAYMENT_TYPE',
  INVALID_LIABILITIES_PAYMENT_TYPES = 'INVALID_LIABILITIES_PAYMENT_TYPES',
  READ_ONLY = 'READ_ONLY',
  UNKNOWN_CART_EXCEPTION = 'UNKNOWN_CART_EXCEPTION',
  TOP_UP_AMOUNT_BELOW_MIN = 'TOP_UP_AMOUNT_BELOW_MIN',
  TOTAL_AMOUNT_BELOW_MIN = 'TOTAL_AMOUNT_BELOW_MIN',
  COUNT_LIABILITIES_OVER_MAX = 'COUNT_LIABILITIES_OVER_MAX',
  TOTAL_AMOUNT_OVER_MAX = 'TOTAL_AMOUNT_OVER_MAX',
  TOTAL_AMOUNT_OVER_INDIVIDUAL_LIMIT = 'TOTAL_AMOUNT_OVER_INDIVIDUAL_LIMIT',
  OVERDUE_INSTALMENT = 'OVERDUE_INSTALMENT',
  HAVE_PAYKA = 'HAVE_PAYKA',
  TOP_UP_CANNOT_BE_EXECUTED_FOR_PAYMENT = 'TOP_UP_CANNOT_BE_EXECUTED_FOR_PAYMENT',
  TOP_UP_CANNOT_BE_MIXED_WITH_STANDARD_LIABILITIES = 'TOP_UP_CANNOT_BE_MIXED_WITH_STANDARD_LIABILITIES'
}
